import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=529532d0&scoped=true"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"
import style0 from "./Saturation.vue?vue&type=style&index=0&id=529532d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529532d0",
  null
  
)

export default component.exports